module.exports = __webpack_public_path__ + "img/sample-west-new.54f85333.png";